import { createSlice } from "@reduxjs/toolkit";
import { LOADER_SLICE } from "../constants";

export const loaderSlice = createSlice({
  name: LOADER_SLICE,
  initialState: {
    isTableLoading: false,
    isFullScreenLoading: false,
  },
  reducers: {
    tableLoadingSlice: (state, action) => {
      const data = {
        ...state,
        isTableLoading: action.payload,
      };

      return (state = data);
    },

    fullScreenLoadingSlice: (state, action) => {
      const data = {
        ...state,
        isFullScreenLoading: action.payload,
      };

      return (state = data);
    },
  },
});

export const { tableLoadingSlice, fullScreenLoadingSlice } =
  loaderSlice.actions;

export default loaderSlice.reducer;
